import Api from './baseApi';

export default {
  getRefineries: () => Api.get('/api/Refineries'),
  createRefinery: (payload) => Api.post('/api/Refineries', payload),
  updateRefinery: (id, payload) => Api.put(`/api/Refineries/${id}`, payload),
  deleteRefinery: (id) => Api.delete(`/api/Refineries/${id}`),

  canView: () => Api.get('/api/Refineries/can-view'),
  getReconciliation: () => Api.get('/api/Refineries/reconciliation'),
  recordIntake: (payload) => Api.post('/api/Refineries/intake', payload),
  giveGold: (payload) => Api.post('/api/Refineries/give', payload),
  getHistory: (refineryId, startDate, endDate, barcode) => Api.get('/api/Refineries/history', { params: { refineryId, startDate, endDate, barcode } }),
};
